import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import ScrollToTop from './components/ScrollToTop';
import Home from './pages/Home';
import Equipo from './components/Equipo';
import HistoriaPage from './pages/HistoriaPage';
import BodegasPage from './pages/BodegasPage';
import KitDeMarcaPage from './pages/KitDeMarcaPage';
import PaymentSuccess from './components/PaymentSuccess';
import PaymentFailure from './components/PaymentFailure';
import PaymentPending from './components/PaymentPending';

function App() {
  return (
    <Router>
      <ScrollToTop />
      <div className="App">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/equipo" element={<Equipo />} />
          <Route path="/historia" element={<HistoriaPage />} />
          <Route path="/bodegas" element={<BodegasPage />} />
          <Route path="/vinedos" element={<Navigate to="/bodegas#vinedos" replace />} />
          <Route path="/kit-de-marca" element={<KitDeMarcaPage />} />
          <Route path="/success" element={<PaymentSuccess />} />
          <Route path="/failure" element={<PaymentFailure />} />
          <Route path="/pending" element={<PaymentPending />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
